/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyEngine_Models_SESurveyConfirmOperation {
    PENDING_CONFIRMATION = 'pendingConfirmation',
    REMOVE_FROM_ALL_SESSIONS = 'removeFromAllSessions',
}
